// extracted by mini-css-extract-plugin
export default {"footerAction":"FooterAction-footerAction-y7_"};